/**
 * Streckt ein Element bis zum unteren Rand des Fensters.
 *
 * Gedacht fuer die scrollenden Tabellenflaechen der Auswertungen. Die Alternative
 * waere eine Hoehe wie calc(100vh - 15rem), aber die 15rem sind geraten: sie muessen
 * Seitenkopf, Bedienleiste und Hinweiszeile treffen und stimmen nicht mehr, sobald
 * sich davon etwas aendert. Gemessen wird deshalb, wo das Element tatsaechlich
 * beginnt.
 */
export interface FitOptions {
  /** Abstand zum unteren Fensterrand, in Pixeln. Passend zum Innenabstand der Seite. */
  gap?: number;
  /** Mindesthoehe, damit die Tabelle auf kleinen Fenstern nicht zusammenfaellt. */
  min?: number;
}

export function fitToViewport(el: HTMLElement, opts: FitOptions = {}): void {
  const { gap = 24, min = 240 } = opts;
  const top = el.getBoundingClientRect().top;
  // Ist das Element ausgeblendet oder noch nicht im Dokument, ergibt die Messung 0.
  // Dann lieber nichts setzen als eine falsche Hoehe festschreiben.
  if (top <= 0) return;
  el.style.height = `${Math.max(min, Math.round(window.innerHeight - top - gap))}px`;
}

/**
 * Wie fitToViewport, bleibt aber an der Fenstergroesse dran. Das Abmelden laeuft ueber
 * das Signal, das die Seite ohnehin fuer ihre uebrigen Listener fuehrt.
 */
export function fitOnResize(el: HTMLElement, signal: AbortSignal, opts: FitOptions = {}): void {
  fitToViewport(el, opts);
  window.addEventListener("resize", () => fitToViewport(el, opts), { signal });
}
